import axios from "axios";

const WEAVIATE_HOST = "http://localhost:8080"; // Replace with your Weaviate host

export const fetchAndQuery = async (pid: string) => {
  try {
    // Step 1: Fetch the object by `pid`
    const response = await axios.post(`${WEAVIATE_HOST}/v1/graphql`, {
      query: `
        {
          Get {
            Paragraph(where: {
              path: ["pid"],
              operator: Equal,
              valueString: "${pid}"
            }) {
              _additional {
                id
                vector
              }
              pid
            }
          }
        }
      `,
    });

    const objects = response.data.data.Get.Paragraph;
    if (!objects || objects.length === 0) {
      throw new Error("No object found with the specified pid.");
    }

    const queryVector = objects[0]._additional.vector;
    // console.log("Query Vector:", queryVector);

    // Step 2: Search for the 10 most similar vectors
    const similarResults = await axios.post(`${WEAVIATE_HOST}/v1/graphql`, {
      query: `
        {
          Get {
            Paragraph(nearVector: {
              vector: ${JSON.stringify(queryVector)}
            }, limit: 10) {
              pid
              _additional {
                distance
              }
            }
          }
        }
      `,
    });

    // Return the results in a simplified format
    return similarResults.data.data.Get.Paragraph.map((obj: any) => ({
      pid: obj.pid,
      distance: obj._additional.distance,
    }));
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const fetchAndQueryItems = async (itemid: string) => {
  // console.log("itemid", itemid)
  try {
    // Step 1: Fetch the object by `pid`
    const response = await axios.post(`${WEAVIATE_HOST}/v1/graphql`, {
      query: `
        {
          Get {
            Item(where: {
              path: ["itemShortId"],
              operator: Equal,
              valueString: "${itemid}"
            }) {
              _additional {
                id
                vector
              }
              itemShortId,
            }
          }
        }
      `,
    });
    
    const objects = response.data.data.Get.Item;
    if (!objects || objects.length === 0) {
      throw new Error("No object found with the specified itemid.");
    }

    const queryVector = objects[0]._additional.vector;
    // console.log("Query Vector:", queryVector);

    // Step 2: Search for the 10 most similar vectors
    const similarResults = await axios.post(`${WEAVIATE_HOST}/v1/graphql`, {
      query: `
        {
          Get {
            Item(nearVector: {
              vector: ${JSON.stringify(queryVector)},
              certainty: 0.5
            }) {
              _additional {
                distance
                certainty
              }
              itemShortId,
              item,
              longTitle,
              author,
              authorTitle
              questionTitle
            }
          }
        }
      `,
    });
    // Return the results in a simplified format
    // console.log("similarResults", similarResults.data.data.Get.Item)
    return similarResults.data.data.Get.Item.map((obj: any) => ({
      item: obj.item,
      itemShortId: obj.itemShortId,
      longTitle: obj.longTitle,
      author: obj.author,
      authorTitle: obj.authorTitle,
      questionTitle: obj.questionTitle,
      distance: obj._additional.distance,
      certainty: obj._additional.certainty,
    }));
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const fetchAndQueryBlocks = async (itemid: string) => {
  // console.log("itemid", itemid)
  try {
    // Step 1: Fetch the object by `pid`
    const response = await axios.post(`${WEAVIATE_HOST}/v1/graphql`, {
      query: `
        {
          Get {
            Block(where: {
              path: ["blockShortId"],
              operator: Equal,
              valueString: "${itemid}"
            }) {
              _additional {
                id
                vector
              }
              blockShortId,
            }
          }
        }
      `,
    });
    
    const objects = response.data.data.Get.Block;
    if (!objects || objects.length === 0) {
      throw new Error("No object found with the specified block id.");
    }

    const queryVector = objects[0]._additional.vector;
    // console.log("Query Vector:", queryVector);

    // Step 2: Search for the 10 most similar vectors
    const similarResults = await axios.post(`${WEAVIATE_HOST}/v1/graphql`, {
      query: `
        {
          Get {
            Block(nearVector: {
              vector: ${JSON.stringify(queryVector)},
              certainty: 0.7
            }) {
              _additional {
                distance
                certainty
              }
              blockShortId,
              block,
              longTitle,
              author,
              authorTitle
            }
          }
        }
      `,
    });
    
    // Return the results in a simplified format
    // console.log("similarResults", similarResults.data.data.Get.Item)
    return similarResults.data.data.Get.Block.map((obj: any) => ({
      item: obj.block,
      itemShortId: obj.blockShortId,
      longTitle: obj.longTitle,
      author: obj.author,
      authorTitle: obj.authorTitle,
      distance: obj._additional.distance,
      certainty: obj._additional.certainty,
    }));
    
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};